module.exports = __webpack_public_path__ + "files/ce2eb6f59329189b9942da868eaa3c44.png";